import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import { ElementDefinition, ImageElement } from "@easy-email-pro-core/typings";
import { BasicBlock } from "@easy-email-pro-core/components";
import React from "react";

const defaultData: ElementDefinition<ImageElement>["defaultData"] = {
  attributes: {
    align: "center",
    border: "0",
    height: "auto",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    target: "_blank",
  },
  data: {},
};

export const Image = createBlock<ImageElement>({
  get name() {
    return t("Image");
  },
  void: true,
  defaultData,
  type: BasicType.IMAGE,
  create: (payload) => {
    const defaultData: ImageElement = {
      type: BasicType.IMAGE,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.IMAGE,
  render(params) {
    return <BasicBlock params={params} tag="mj-image" />;
  },
});
